import React from "react";
import { CallButton } from "./PhoneButtons";

// Barre d'appel fixe en bas d'écran (numéro « Sticky Bar », ou numéro propre à la page marque).
export function StickyBar({ phones }) {
  return (
    <div className="sticky-bar">
      <CallButton phone={phones.sticky} label="Llamar a un asesor" className="sticky-btn" />
    </div>
  );
}
